<template>
  <div id="app">
    <!-- Preloader -->
    <div class="loader-wrapper">
      <div class="loader"></div>
    </div>
    <!-- Preloader end -->
    <b-navbar type="light" class="navbar-light theme-nav fixed-top" toggleable="lg" fixed="top" v-b-scrollspy:nav-scroller
      style="flex-direction: column;padding: 0;">
      <div class="header-top-bar bg-dark" style="width: 100%;">
        <div class="d-flex justify-content-between" style="width: 90%; margin: auto;">
          <div class="header-top-bar-area  col-xs area-left">
            <i class="fa fa-phone"></i>
            <span>0800 750 5523</span>
            <i class="fa fa-envelope"></i>
            <span>vendas@prodo.com.br</span>
          </div>
          <div class="header-top-bar-area  col-xs-fit area-right">
            <div data-type="group" data-dynamic-mod="true" class="top-bar-social-icons">
              <a target="_blank" class="social-icon"
                href="https://www.facebook.com/prodosistemas/?view_public_for=103019934659801">
                <i class="fa fa-facebook-official"></i>
              </a> <a target="_blank" class="social-icon" href="https://instagram.com/prodosistemas">
                <i class="fa fa-instagram"></i>
              </a> <a target="_blank" class="social-icon"
                href="http://api.whatsapp.com/send?1=pt_BR&amp;phone=554934422534">
                <i class="fa fa-whatsapp"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <router-view name="navbar"></router-view>
    </b-navbar>
    <router-view />
    <vue-progress-bar></vue-progress-bar>
    <b-modal ref="my-modal" :body-bg-variant="bodyBgVariant" size="lg" centered hide-footer hide-header>
      <button type="button" aria-label="Close" class="close" @click="hideModal">×</button>
      <div class="mbody ml-6 mt-5">
        <p style="font-size: 16pt; margin-top: 1em;">CHEGOU O NOVO APP</p>
        <p class="text-white" style="font-size: 45px; font-weight: 900;">Força de Venda</p>
        <p style="font-size: 13pt;">O app feito para agilizar as suas vendas e melhorar a experiência de seus clientes.
          Para conhecer o app acesse
          <a href="https://rottamobile.com.br" class="btn-mini-cadastro" target="_blank" style="text-decoration: revert;">
            rottamobile.com.br
          </a>
        </p>
        <p style="margin-left: 5rem;">
          <!--https://play.google.com/store/apps/details?id=com.hotline.consultapreco--->
          <a href="https://play.google.com/store/apps/details?id=com.hotline.forcadevendas" target="_blank">
            <!-- <img class="img-fluid" src="./img/QR-CODE.png" alt="RapidServer Tablets" style="width: 60%;"> -->
          </a>
        </p>
        <p class="mb-5 col-10" style="font-size: 13pt;">
          Escaneie o <span class="btn-mini-cadastro">QR CODE</span> ou <a class="btn-mini-cadastro"
            href="https://play.google.com/store/apps/details?id=com.hotline.forcadevendas">clique aqui</a> para fazer o
          download do aplicativo.
        </p>
      </div>
    </b-modal>
  </div>
</template>
<script>
import $ from 'jquery'
import HomePage from './views/home_one'
export default {
  components: { HomePage },
  name: 'App',
  data() {
    return {
      bodyBgVariant: 'light',
    }
  },
  mounted() {
    //  [App.vue specific] When App.vue is finish loading finish the progress bar
    this.$Progress.finish()
    this.loader()
  },
  created() {
    //  [App.vue specific] When App.vue is first loaded start the progress bar
    this.$Progress.start()
  },
  methods: {
    showModal() {
      this.$refs['my-modal'].show()
    },
    hideModal() {
      this.$refs['my-modal'].hide()
    },
    loader() {
      $(document).ready(function () {
        // ----------------------------------------
        //  Pre Loader
        // ----------------------------------------
        $(window).on('load', function () {
          $('.loader-wrapper').fadeOut('slow')
          $('.loader-wrapper').remove('slow')
        })
      })
      //this.showModal()
    }
  }
}
</script>
<style scoped> 
.modal-body {
  background-color: red !important;
}
#__BVID__42___BV_modal_header_ {
   border: none !important;
 }
</style>
<style>
p {
  text-transform: initial !important;
}
.modal-body {
  background: linear-gradient(45deg, #1d4557 0%, #1b897f 50%, #18e7d3 100%);
}
.mbody p{
  color: #fff;
  padding: 0 3rem;
}

.header-top-bar,
.header-top-bar i {
  color: white !important;
  padding: 5px;
}

.darkHeader.theme-nav .nav-item {
  padding: 8px 0 8px 7px !important;
}

.social-icon i {
  font-size: 20px;
}

.tap-top {
  background: linear-gradient(to top, #18e7d3, #1d4456) !important;
}


/* Firefox */
* {
  scrollbar-width: auto;
  scrollbar-color: #18e7d3 #ffffff;
}

/* Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 10px;
}

*::-webkit-scrollbar-track {
  background: #343a40;
}

*::-webkit-scrollbar-thumb {
  background-color: #18e7d3;
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px #1f3a4e;
  background-image: -webkit-linear-gradient(90deg, transparent, #1f3a4e88 50%, transparent, transparent);
  background-image: -webkit-gradient(linear, 40% 0%, 75% 84%, from(#1f3a4e), to(#1f3a4e), color-stop(.6, #18e7d3));
  /* border: 2px solid #1f3a4e; */
}

@media (min-width: 1600px) {

  .container,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    max-width: 1500px;
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue